export const MISSING_IMAGE = {
  url: 'https://images.ctfassets.net/2v76bt8y8dea/6FLIw9rVcwHWHpI31domil/c1198fe9c848fa3b5815d2235bfe9a72/na-image.webp',
  altText: 'Image not available',
  height: 824,
  width: 824,
}
